import { Link } from 'react-router-dom';

const categoryData = [
  {
    slug: 'riju',
    name: '日剧',
    nameJa: '日本ドラマ',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20drama%20series%20poster%20collection%20elegant%20minimalist%20design%20with%20warm%20lighting%20and%20clean%20aesthetic%2C%20cinematic%20atmosphere%2C%20professional%20photography%20style%2C%20soft%20gradient%20background%20in%20warm%20cream%20tones&width=400&height=533&seq=cat-jdrama-01&orientation=portrait',
  },
  {
    slug: 'handong',
    name: '韩剧',
    nameJa: '韓国ドラマ',
    image: 'https://readdy.ai/api/search-image?query=Korean%20drama%20series%20poster%20collection%20modern%20romantic%20design%20with%20soft%20warm%20lighting%2C%20cinematic%20Korean%20aesthetic%2C%20elegant%20composition%2C%20cream%20and%20beige%20background%20tones&width=400&height=533&seq=cat-kdrama-01&orientation=portrait',
  },
  {
    slug: 'dongman',
    name: '动漫',
    nameJa: 'アニメ',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20art%20style%20illustration%20collection%20vibrant%20colors%20with%20soft%20background%2C%20clean%20modern%20design%2C%20warm%20atmosphere%2C%20artistic%20composition%20with%20cream%20gradient%20background&width=400&height=533&seq=cat-anime-01&orientation=portrait',
  },
  {
    slug: 'zongyi',
    name: '综艺',
    nameJa: 'バラエティ',
    image: 'https://readdy.ai/api/search-image?query=Variety%20show%20vibrant%20colorful%20poster%20design%20with%20playful%20atmosphere%2C%20warm%20lighting%2C%20clean%20modern%20composition%2C%20soft%20cream%20background%2C%20entertainment%20style%20photography&width=400&height=533&seq=cat-variety-01&orientation=portrait',
  },
  {
    slug: 'dianying',
    name: '电影',
    nameJa: '映画',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20and%20Korean%20cinema%20movie%20poster%20collection%20cinematic%20atmosphere%2C%20warm%20golden%20lighting%2C%20elegant%20minimalist%20design%2C%20soft%20cream%20gradient%20background%2C%20professional%20film%20photography%20style&width=400&height=533&seq=cat-movie-01&orientation=portrait',
  },
  {
    slug: 'yinyue',
    name: '音乐',
    nameJa: '音楽',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20Korean%20music%20concert%20stage%20atmosphere%20with%20warm%20spotlight%20and%20soft%20gradient%20background%2C%20elegant%20performance%20photography%20style%2C%20clean%20composition%2C%20cream%20and%20golden%20tones&width=400&height=533&seq=cat-music-01&orientation=portrait',
  },
];

export default function CategoryGrid() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950 mb-3">
            探索内容分类
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            涵盖日剧、韩剧、动漫、综艺、电影、音乐六大板块，全方位满足您的日韩内容需求
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-5">
          {categoryData.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative overflow-hidden rounded-lg aspect-[3/4] cursor-pointer"
            >
              <img
                src={cat.image}
                alt={cat.name}
                className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-3 md:p-4">
                <h3 className="text-sm md:text-base font-semibold text-background-50 mb-1">
                  {cat.name}
                </h3>
                <p className="text-xs text-background-50/70 hidden md:block">
                  {cat.nameJa}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}